import React from "react"

type Props = {
  Title: JSX.Element
  Right?: JSX.Element
  type?: "choose" | "none" | "loading" | "remove"
  onClick?: () => void
  Left?: JSX.Element
  Subtitle?: JSX.Element
}

export const LIST_ITEM_HEIGHT = 58

export const ListItem = ({
  Title,
  Right,
  type,
  onClick,
  Left,
  Subtitle,
}: Props) => {
  return (
    <div
      className={`flex flex-col w-full gap-2 rounded ${type === "choose" ? "hover:bg-ctaLight" : ""}`}
    >
      <div
        onClick={() => type === "choose" && onClick && onClick()}
        className={`text-ctaMain [&_.choose-button]:hover:min-w-auto [&_.choose-button]:hover:flex [&_.choose-button]:hover:${type == "choose" ? "visible" : "hidden"} [&_.choose-button]:${type == "choose" ? "visible" : "hidden"}  flex flex-row h-[${LIST_ITEM_HEIGHT}px] w-full justify-between items-center cursor-${type === "choose" ? "pointer" : "regular"} p-2 gap-[2px] md:p-4 md:gap-4`}
      >
        <div className="flex w-full items-center gap-3 md:gap-4">
          {Left && (
            <div
              className={`${type === "none" ? "opacity-50" : "opacity-100"}`}
            >
              {Left}
            </div>
          )}
          <div className="flex flex-col gap-2 items-between w-full">
            {Title}
            {Subtitle}
          </div>
        </div>
        {Right}
      </div>
    </div>
  )
}
